export default __webpack_public_path__ + "static/media/SVM_thirdprize.578c3158.jpg";